import { iconColorBgColor } from "../../utils/colorBgColorMap";
import { renderIcon } from "../../utils/iconHelper";

const WidgetIcon = (props) => {
    const { icon, iconId, type } = props

    return (
        <div className="icon-box" style={{background: iconColorBgColor[type].bgColor}}>
            {iconId ? renderIcon(iconId) : icon}
        </div>
    )
}

export default WidgetIcon